<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M18.62 9.31 14.7 5.38a1.3 1.3 0 0 0-1.84 0L9.5 8.76a4.41 4.41 0 0 0-4 .94 1.3 1.3 0 0 0-.11 1.93l2.95 2.94-2.58 2.58a.78.78 0 1 0 1.1 1.1l2.58-2.58 2.95 2.95c.24.24.57.38.91.38h.1a1.3 1.3 0 0 0 .94-.52c.3-.4.7-1.04.93-1.81.23-.77.23-1.49.01-2.17l3.35-3.36a1.3 1.3 0 0 0 0-1.83Zm-4.81 4.46a.78.78 0 0 0-.15.9c.23.44.45 1.36-.4 2.63l-6.57-6.56a2.77 2.77 0 0 1 2.66-.4.76.76 0 0 0 .9-.14l3.52-3.54 3.57 3.57-3.53 3.54Z"
      />
    </svg>
  </span>
</template>
